import type { SetState } from "zustand";

import type { FormQuestionSuggestionState, FormQuestionSuggestionWithId } from "../../types";
import type { AskPerformYardState } from "../types";

export const createFormQuestionSlice = (set: SetState<AskPerformYardState>) => ({
	formQuestionSuggestionStates: [] as FormQuestionSuggestionState[],

	setFormQuestionSuggestions: (messageId: string, suggestions: FormQuestionSuggestionWithId[]) => {
		set((state) => {
			const msgIdx = state.messages.findIndex((m) => m.id === messageId);
			const updatedMessages = state.messages.slice();
			if (msgIdx !== -1) {
				updatedMessages[msgIdx] = { ...updatedMessages[msgIdx], formQuestionSuggestions: suggestions };
			}

			const newStates: FormQuestionSuggestionState[] = suggestions.map((s) => ({
				suggestion: s,
				status: "pending" as const,
				messageId,
			}));

			// Replace any existing states for this messageId; preserve states tied to other messages
			// (added/deleted suggestions on prior messages should keep their status).
			const otherStates = state.formQuestionSuggestionStates.filter((fs) => fs.messageId !== messageId);

			return {
				messages: updatedMessages,
				formQuestionSuggestionStates: [...otherStates, ...newStates],
			};
		});
	},

	markFormQuestionAdded: (suggestionId: string) => {
		set((state) => ({
			formQuestionSuggestionStates: state.formQuestionSuggestionStates.map((fs) =>
				fs.suggestion.id === suggestionId ? { ...fs, status: "added" as const } : fs
			),
		}));
	},

	markFormQuestionDeleted: (suggestionId: string) => {
		set((state) => ({
			formQuestionSuggestionStates: state.formQuestionSuggestionStates.map((fs) =>
				fs.suggestion.id === suggestionId ? { ...fs, status: "deleted" as const } : fs
			),
		}));
	},
});
